import {MenuCategoryResponse} from "./menu-category-response";
import {ProductSlimInfo} from "libs/shared-models/src/lib/restaurant/product-slim-info";

export class CategoryLocalResponse {
    category: MenuCategoryResponse = new MenuCategoryResponse();
    products: ProductSlimInfo[] = [];
}
